export enum PPPSubRoutes {
	SEZNAM = 'seznam',
	DETAIL = 'detail',
	REKLAMACE = 'reklamace',
	ZAPIS = 'zapis',
	UKONCENI = 'ukonceni',
}
